'use client'
import type { PropsWithChildren } from 'react'

const VaultV2TimelocksLayout = ({ children }: PropsWithChildren) => {
  return (
    <div
      className="gap-sm flex scroll-mt-[calc(var(--sticky-offset,0px)+16px)] flex-col"
      id="timelocks-section"
      data-testid="vault-v2-timelocks"
    >
      <span className="text-foreground text-sm">Timelocks</span>
      {children}
    </div>
  )
}

export default VaultV2TimelocksLayout
